import { useRuntimeConfig } from 'nuxt/app'

export const useTokensStore = defineStore('tokens', () => {
  const { MIDDLEWARE_URL, DEX_BACKEND_URL, NETWORK_NAME } = useRuntimeConfig().public
  const featureFlags = useFeatureFlags()
  const axios = useAxios()
  const rawListedTokens = ref(null)
  const allTokens = ref(null)
  const selectedTokenName = ref(null)
  const allTokensCount = ref(null)

  const selectedTokens = computed(() => {
    if (!featureFlags.dex) {
      return allTokens.value
    }

    return selectedTokenName.value?.key === 'listedTokens' && NETWORK_NAME !== 'TESTNET' ? listedTokens.value : allTokens.value
  })
  const selectedTokensCount = computed(() => {
    if (!featureFlags.dex) {
      return allTokensCount.value
    }

    return selectedTokenName.value?.key === 'listedTokens' ? listedTokens.value?.data?.length : allTokensCount.value
  })

  const listedTokens = computed(() =>
    rawListedTokens.value
      ? adaptListedTokens(rawListedTokens.value)
      : null,
  )

  function fetchTokens({ queryParameters, limit } = {}) {
    return Promise.allSettled([
      fetchAllTokens({ queryParameters, limit }),
      fetchListedTokens(),
    ])
  }

  async function fetchAllTokens({ queryParameters, limit } = {}) {
    allTokens.value = null
    const effectiveLimit = limit || 10
    const defaultPath = `/aex9?by=name&direction=forward&limit=${effectiveLimit}`
    const { data } = await axios.get(`${MIDDLEWARE_URL}${queryParameters || defaultPath}`)
    allTokens.value = data
  }

  async function fetchListedTokens() {
    if (!featureFlags.dex) {
      return
    }

    rawListedTokens.value = null
    const { data } = await axios.get(`${DEX_BACKEND_URL}/tokens/listed`)
    rawListedTokens.value = data
  }

  async function fetchTokensCount() {
    const { data } = await axios.get(`${MIDDLEWARE_URL}/aex9/count`)
    allTokensCount.value = data.data
  }

  return {
    selectedTokens,
    selectedTokenName,
    allTokensCount,
    selectedTokensCount,
    fetchTokens,
    fetchTokensCount,
  }
})
